"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var delay_1 = __importDefault(require("delay"));
var moment_1 = __importDefault(require("moment"));
var __1 = require("../");
var mapShipmentLogApiToSdk_1 = require("../../utils/mapShipmentLogApiToSdk");
var Model_1 = require("../Model");
var SHIPMENT_STATES;
(function (SHIPMENT_STATES) {
    SHIPMENT_STATES["DATA_RECEIVED"] = "DATA_RECEIVED";
    SHIPMENT_STATES["DATA_PROCESSED"] = "DATA_PROCESSED";
    SHIPMENT_STATES["SHIPMENT_SORTED"] = "SHIPMENT_SORTED";
    SHIPMENT_STATES["SHIPMENT_SORTED_AT_SUB_DEPOT"] = "SHIPMENT_SORTED_AT_SUB_DEPOT";
    SHIPMENT_STATES["SHIPMENT_ACCEPTED_BY_DRIVER"] = "SHIPMENT_ACCEPTED_BY_DRIVER";
    SHIPMENT_STATES["SHIPMENT_DELIVERED"] = "SHIPMENT_DELIVERED";
    SHIPMENT_STATES["SHIPMENT_DELIVERED_TO_NEIGHBOR"] = "SHIPMENT_DELIVERED_TO_NEIGHBOR";
    SHIPMENT_STATES["SHIPMENT_NOT_DELIVERED"] = "SHIPMENT_NOT_DELIVERED";
    SHIPMENT_STATES["PICKUP_DRIVER_ASSIGNED"] = "PICKUP_DRIVER_ASSIGNED";
    SHIPMENT_STATES["PICKUP_ACCEPTED_BY_DRIVER"] = "PICKUP_ACCEPTED_BY_DRIVER";
    SHIPMENT_STATES["PICKUP_PICKED_UP"] = "PICKUP_PICKED_UP";
    SHIPMENT_STATES["PICKUP_ARRIVED_ON_TIME"] = "PICKUP_ARRIVED_ON_TIME";
    SHIPMENT_STATES["LINEHAUL_IN_TRANSIT"] = "LINEHAUL_IN_TRANSIT";
    SHIPMENT_STATES["LINEHAUL_ARRIVED_ON_TIME"] = "LINEHAUL_ARRIVED_ON_TIME";
    SHIPMENT_STATES["RETURN_ASSIGNED_TO_LINEHAUL"] = "RETURN_ASSIGNED_TO_LINEHAUL";
    SHIPMENT_STATES["RETURN_ACCEPTED_BY_DRIVER"] = "RETURN_ACCEPTED_BY_DRIVER";
    SHIPMENT_STATES["RETURN_ACCEPTED_BY_TRUNKRS"] = "RETURN_ACCEPTED_BY_TRUNKRS";
    SHIPMENT_STATES["RETURN_ASSIGNED_TO_PICKUP"] = "RETURN_ASSIGNED_TO_PICKUP";
    SHIPMENT_STATES["RETURN_ACCEPTED_BY_PICKUP_DRIVER"] = "RETURN_ACCEPTED_BY_PICKUP_DRIVER";
    SHIPMENT_STATES["RETURN_ACCEPTED_BY_SENDER"] = "RETURN_ACCEPTED_BY_SENDER";
    SHIPMENT_STATES["RETURN_SHIPMENT_TO_SENDER"] = "RETURN_SHIPMENT_TO_SENDER";
    SHIPMENT_STATES["CHANGE_SHIPMENT_POST_PONED"] = "CHANGE_SHIPMENT_POST_PONED";
    SHIPMENT_STATES["CHANGE_SHIPMENT_ADDRESS_CHANGED"] = "CHANGE_SHIPMENT_ADDRESS_CHANGED";
    SHIPMENT_STATES["CHANGE_SHIPMENT_NEIGHBOUR_CHANGE"] = "CHANGE_SHIPMENT_NEIGHBOUR_CHANGE";
    SHIPMENT_STATES["EXCEPTION_PICKUP_REFUSED_BY_DRIVER"] = "EXCEPTION_PICKUP_REFUSED_BY_DRIVER";
    SHIPMENT_STATES["EXCEPTION_PICKUP_NOT_PICKED_UP"] = "EXCEPTION_PICKUP_NOT_PICKED_UP";
    SHIPMENT_STATES["EXCEPTION_PICKUP_ARRIVED_LATE"] = "EXCEPTION_PICKUP_ARRIVED_LATE";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_NOT_ARRIVED"] = "EXCEPTION_SHIPMENT_NOT_ARRIVED";
    SHIPMENT_STATES["EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL"] = "EXCEPTION_LINEHAUL_NOT_ON_LINEHAUL";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_MIS_SORTED"] = "EXCEPTION_SHIPMENT_MIS_SORTED";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER"] = "EXCEPTION_SHIPMENT_DECLINED_BY_DRIVER";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_MISSING"] = "EXCEPTION_SHIPMENT_MISSING";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_LOST"] = "EXCEPTION_SHIPMENT_LOST";
    SHIPMENT_STATES["EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL"] = "EXCEPTION_RETURN_NOT_ACCEPTED_BY_LINEHAUL";
    SHIPMENT_STATES["EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP"] = "EXCEPTION_RETURN_NOT_ACCEPTED_BY_PICKUP";
    SHIPMENT_STATES["EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER"] = "EXCEPTION_RETURN_NOT_ACCEPTED_BY_SENDER";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER"] = "EXCEPTION_SHIPMENT_CANCELLED_BY_SENDER";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS"] = "EXCEPTION_SHIPMENT_CANCELLED_BY_TRUNKRS";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_DESTROYED"] = "EXCEPTION_SHIPMENT_DESTROYED";
    SHIPMENT_STATES["EXCEPTION_LINEHAUL_ARRIVED_LATE"] = "EXCEPTION_LINEHAUL_ARRIVED_LATE";
    SHIPMENT_STATES["EXCEPTION_SHIPMENT_INVESTIGATE"] = "EXCEPTION_SHIPMENT_INVESTIGATE";
})(SHIPMENT_STATES = exports.SHIPMENT_STATES || (exports.SHIPMENT_STATES = {}));
var ShipmentLog = /** @class */ (function (_super) {
    __extends(ShipmentLog, _super);
    function ShipmentLog(id, shipmentId, recipientId, stateId, timeSlotId, version, userSub, metaId, timestamp) {
        var _this = _super.call(this, id) || this;
        _this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, delay_1.default(1000)];
                    case 1:
                        _a.sent();
                        this.setId = 1000;
                        this.setVersion = 10;
                        return [2 /*return*/, this];
                }
            });
        }); };
        /**
         * fetchState
         * Fetch a state attached to a shipment log
         *
         * @returns {Promise<State>}
         */
        _this.fetchState = function () {
            return _this.fetchNestedModel('setState', __1.State.fetch, 'getStateId');
        };
        _this.fetchRecipient = function () {
            return _this.fetchNestedModel('setRecipient', __1.Recipient.fetch, 'getRecipientId');
        };
        _this.fetchTimeSlot = function () {
            return _this.fetchNestedModel('setTimeSlot', __1.TimeSlot.fetch, 'getTimeSlotId');
        };
        _this.setShipmentId = shipmentId;
        _this.recipientId = recipientId;
        _this.stateId = stateId;
        _this.timeSlotId = timeSlotId;
        _this.version = version;
        _this.userSub = userSub;
        _this.metaId = metaId;
        _this.setTimestamp = timestamp;
        return _this;
    }
    Object.defineProperty(ShipmentLog.prototype, "getShipmentId", {
        /**
         * GETTER
         */
        get: function () {
            return this.shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getShipment", {
        get: function () {
            return this.shipment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getRecipientId", {
        get: function () {
            return this.recipientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getRecipient", {
        get: function () {
            return this.checkIfPropertyIsFetched('recipient', this.fetchRecipient);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getStateId", {
        get: function () {
            return this.stateId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getState", {
        get: function () {
            return this.checkIfPropertyIsFetched('state', this.fetchState);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getTimeSlotId", {
        get: function () {
            return this.timeSlotId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getTimeSlot", {
        get: function () {
            return this.checkIfPropertyIsFetched('timeSlot', this.fetchTimeSlot);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getVersion", {
        get: function () {
            return this.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getUserSub", {
        get: function () {
            return this.userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getMetaId", {
        get: function () {
            return this.metaId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getMeta", {
        get: function () {
            return this.meta;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "getTimestamp", {
        get: function () {
            return this.timestamp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setShipmentId", {
        /**
         * SETTER
         */
        set: function (shipmentId) {
            this.shipmentId = shipmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setShipment", {
        set: function (shipment) {
            this.shipment = shipment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setRecipientId", {
        set: function (recipientId) {
            this.recipientId = recipientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setRecipient", {
        set: function (recipient) {
            this.recipient = recipient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setStateId", {
        set: function (stateId) {
            this.stateId = stateId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setState", {
        set: function (state) {
            this.state = state;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setTimeSlotId", {
        set: function (timeSlotId) {
            this.timeSlotId = timeSlotId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setTimeSlot", {
        set: function (timeSlot) {
            this.timeSlot = timeSlot;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setVersion", {
        set: function (version) {
            this.version = version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setUserSub", {
        set: function (userSub) {
            this.userSub = userSub;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setMetaId", {
        set: function (metaId) {
            this.metaId = metaId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setMeta", {
        set: function (meta) {
            this.meta = meta;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShipmentLog.prototype, "setTimestamp", {
        set: function (timestamp) {
            if (timestamp) {
                this.timestamp = moment_1.default(timestamp);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetch
     * Fetch a shipment log by ID
     *
     * @param {number} shipmentLogId
     * @returns {Promise<ShipmentLog>}
     */
    ShipmentLog.fetch = function (shipmentLogId) { return __awaiter(_this, void 0, void 0, function () {
        var log, sdkLog;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ShipmentLog.makeRequest("/delivery/private/shipment-log/" + shipmentLogId, Model_1.METHOD.GET, {})];
                case 1:
                    log = (_a.sent()).result;
                    sdkLog = mapShipmentLogApiToSdk_1.mapShipmentLogApiToSdk(log);
                    return [2 /*return*/, new ShipmentLog(sdkLog.id, sdkLog.shipmentId, sdkLog.recipientId, sdkLog.stateId, sdkLog.timeSlotId, sdkLog.version, sdkLog.userSub, sdkLog.metaId, sdkLog.timestamp)];
            }
        });
    }); };
    /**
     * fetchByTimeSlotId
     * fetch all shipment logs with version 0 and
     * the given time slot id
     *
     * @param {number} timeSlotId
     * @returns {Promise<any>}
     */
    ShipmentLog.fetchByTimeSlotId = function (timeSlotId) { return __awaiter(_this, void 0, void 0, function () {
        var logs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ShipmentLog.makeRequest("/delivery/private/shipment-log/", Model_1.METHOD.GET, {
                        filter: {
                            where: {
                                timeSlotId: timeSlotId,
                                version: 0,
                            },
                        },
                    })];
                case 1:
                    logs = (_a.sent()).result;
                    return [2 /*return*/, logs.map(function (log) {
                            var sdkLog = mapShipmentLogApiToSdk_1.mapShipmentLogApiToSdk(log);
                            return new ShipmentLog(sdkLog.id, sdkLog.shipmentId, sdkLog.recipientId, sdkLog.stateId, sdkLog.timeSlotId, sdkLog.version, sdkLog.userSub, sdkLog.metaId, sdkLog.timestamp);
                        })];
            }
        });
    }); };
    /**
     * fetchLogsForShipment
     * Fetch all the logs associated to a shipment
     *
     * @param {number} shipmentId
     * @param {boolean} invalidateCache
     * @returns {Promise<any>}
     */
    ShipmentLog.fetchLogsForShipment = function (shipmentId, invalidateCache) {
        if (invalidateCache === void 0) { invalidateCache = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ShipmentLog.fetchLogIdsForShipment(shipmentId, invalidateCache)];
                    case 1:
                        ids = _a.sent();
                        return [2 /*return*/, ids.map(function (id) { return ShipmentLog.fetch(id); })];
                }
            });
        });
    };
    /**
     * fetchLogIdsForShipment
     * Fetch all the log ids associated to a shipment
     * @param {number} shipmentId
     * @param {boolean} invalidateCache
     * @returns {Promise<number>}
     */
    ShipmentLog.fetchLogIdsForShipment = function (shipmentId, invalidateCache) {
        if (invalidateCache === void 0) { invalidateCache = false; }
        return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ShipmentLog.makeRequest("/delivery/functions/fetch-shipment-logs-for-shipment/" + shipmentId + "?state=" + (invalidateCache &&
                            moment_1.default().toISOString()), Model_1.METHOD.GET, {})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ShipmentLog;
}(Model_1.Model));
exports.ShipmentLog = ShipmentLog;
